export default "__VITE_ASSET__BziS$aol__"